// extracted by mini-css-extract-plugin
module.exports = {"pagination":"b429494557--pagination--SIf_R","pages-list":"b429494557--pages-list--OcUXj","page":"b429494557--page--Gby6K"};